import logo from "./logo.svg";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import SubscribeForm from "./Components/SubscribeForm";
import OnePage from "./Components/OnePage";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<OnePage />} />
        <Route path="/suscribeForm" element={<SubscribeForm />} />
      </Routes>
    </div>
  );
}

export default App;
